/**
 * Returns the Google Map instance to the specified destination coordinates.
 * @param {object} options - The options for returning the map to the destination.
 * @param {object} options.map - The Google Map instance to return to the destination.
 * @param {object} options.center - The center coordinates of the destination.
 */
export const returnMapToDestination = ({ map, center, }) => {
    map.panTo(center);
};
